export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Privacy policy`,
    cloneTitleNoun: `accommodation policies`,
    cloneItemNoun: `the policies`,
    editorHintLang: `Privacy policy in {label}`,
    optional: `(optional)`,
    headingOpt1: `Heading 1`,
    headingOpt2: `Heading 2`,
    headingOpt3: `Heading 3`,
    headingNormal: `Normal`,
    tipBold: `Bold`,
    tipItalic: `Italic`,
    tipUnderline: `Underline`,
    tipListOrdered: `Ordered list`,
    tipListBullet: `Bulleted list`,
    tipLink: `Link`,
    tipQuote: `Quote`,
    tipClean: `Clear formatting`,
    charCount: `{count} character | {count} characters`,
    saving: `Saving…`,
    editorPlaceholder: `Write the privacy policy in {label} here…`,
    errNoListing: `Listing not found.`,
    errLoad: `The privacy policy could not be loaded.`,
    errEsRequired: `The policy in Spanish is required.`,
    saveSuccess: `Privacy policy saved successfully.`,
    saveError: `Error saving the policies.`,
  },
  rooms: {
    bulkTitle: `Create rooms in bulk`,
    bulkSubtitle: `Generate several rooms for a type, with an automatic code and an optional description.`,
    available: `Available: {count}`,
    willCreate: `To be created: {count}`,
    needTypeFirst: `First create at least one <b>Room type</b> in order to generate rooms.`,
    labelType: `Type`,
    selectType: `Select a type`,
    labelQuantity: `Quantity`,
    phQuantity: `E.g.: 10`,
    labelPrefix: `Code prefix`,
    phPrefix: `E.g.: A- or 10`,
    optional: `Optional`,
    labelStart: `Start`,
    labelPadding: `Padding`,
    labelDescription: `Description (optional)`,
    phDescription: `It will be applied to the created rooms`,
    nameEqType: `Name = Type`,
    recommended: `(recommended)`,
    example: `Example:`,
    createBulk: `Create in bulk`,
    typeFallback: `Type`,
    previewFormat: `{name} • Code: {code}`,
    noActivePlan: `You do not have an active plan to create rooms.`,
    limitReached: `Limit reached: your plan allows {limit} rooms for this property.`,
    selectTypeWarn: `Select a room type.`,
    invalidQuantity: `Enter a valid quantity.`,
    cannotAddMore: `You cannot add more. Limit: {limit}.`,
    partialCreated: `Only {created} were created because your plan allows {limit} and you had {remaining} left.`,
    planLimitSave: `Your plan allows {limit} rooms. You are trying to save {count}.`,
  },
  images: {
    zipDownloadTitle: `Download all the property images in a ZIP`,
    zipNoImages: `There are no images to download`,
    preparing: `Preparing…`,
    downloadImages: `Download images`,
    loading: `Loading images…`,
    noAccommodations: `No accommodations have been set up yet for this property.`,
    engineCoverTag: `Engine cover`,
    imageCount: `{count} image | {count} images`,
    hotelPhotosDesc: `General photos (courtyard, entrance, reception…) that the customer will see when opening the engine`,
    dragToOrder: `Drag to order the gallery`,
    ordering: `Ordering…`,
    dragTip: `Drag`,
    hotelSectionName: `Hotel photos · common areas`,
    orderUpdated: `Image order updated.`,
    orderError: `The image order could not be updated.`,
    downloadError: `The images could not be downloaded.`,
  },
};
